import {useState, useEffect} from "react";
import React from 'react';
import "./content.css";
import logo from "../../images/footerLogo.png";
import loading from "../../images/website_loading.gif"
import { Accordion, Container } from "react-bootstrap";
import {
  Connection,
  PublicKey,
  Transaction,
  clusterApiUrl,
  SystemProgram,
  TransactionInstruction,
  SendOptions,
  LAMPORTS_PER_SOL,
  Keypair,
  
} from "@solana/web3.js";
import Unity, { UnityContext,IUnityconfig_web3 } from "react-unity-webgl";
import { Creator, Metadata, MetadataDataData } from '@metaplex-foundation/mpl-token-metadata';
import { Buffer } from "buffer";
import {Token,ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID} from "@solana/spl-token"
import {sendAndConfirmTransaction  } from "@solana/web3.js"




var ageTokenBalance = "";
var allTokens = [];



const network = "https://api.mainnet-beta.solana.com";
const connection = new Connection(network);
const Token_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID = new PublicKey(
  "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
);



const getProvider = () => {
  if ("solana" in window) {
    const provider = window.solana;
    if (provider.isPhantom) {
      return provider;
    }
    
  }
  else
  {
    console.log("provider is not phantom")
  }
};

var buildUrl = "./webgl/Build/";
var loaderUrl = buildUrl + "/webgl.loader.js";

const config_web3 = new UnityContext({
  loaderUrl: buildUrl + "webgl.loader.js",
  dataUrl: buildUrl + "webgl.data.unityweb",
  frameworkUrl: buildUrl + "webgl.framework.js.unityweb",
  codeUrl: buildUrl + "webgl.wasm.unityweb",
  
});
const config_guest = new UnityContext({
  loaderUrl: "./guest/Build/guest.loader.js",
  dataUrl:  "./guest/Build/guest.data.unityweb",
  frameworkUrl:  "./guest/Build/guest.framework.js.unityweb",
  codeUrl:  "./guest/Build/guest.wasm.unityweb",
  
});
var script = document.createElement("script");
script.src = loaderUrl;










function Content() {
  const [connected, setConnected] = useState<boolean>(false);
  const [progression, setProgression] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [guest,setGuest] = useState<boolean>(false);
  const reward = LAMPORTS_PER_SOL / Number(process.env.REACT_APP_Finger_Reward) 
  const charge = LAMPORTS_PER_SOL / Number(process.env.REACT_APP_Finger_Charge)

  useEffect(function () {
    config_web3.on("loaded", function () {
      setIsLoaded(true);
      config_web3.setFullscreen(true);
    });
  }, []);

  useEffect(function () {
    config_web3.on("progress", function (progression) {
      setProgression(progression);
    });
  }, []);
  useEffect(function () {
    config_guest.on("loaded", function () {
      setIsLoaded(true);
      config_guest.setFullscreen(true);
    });
  }, []);

  useEffect(function () {
    config_guest.on("progress", function (progression) {
      setProgression(progression);
    });
  }, []);

  
 
  async function connectWallet()
{
const provider = getProvider();
provider.connect().then(async () =>{
  console.log("connected")
  console.log(provider.publicKey.toString())
  
  setConnected(true)
  
})
}


async function playAsGuest()
{

  setGuest(true);
  
}
async function GetNFT()
{
  const provider = getProvider();
  
  
  const nftsmetadata = await Metadata.findDataByOwner(connection, provider.publicKey);
 // Fetching the NFTs in wallet
 for (let index = 0; index < nftsmetadata.length; index++) 
 {
  const metadataUri = await fetch(nftsmetadata[index].data.uri)
  
  if (metadataUri.status === 200) 
  {      
    allTokens.push(await metadataUri.json());
  }

 }

 // Filter the NFTs and attributes
 for (let index = 0; index < allTokens.length; index++) 
 {
  
  if(allTokens[index].collection.name == "ThugMonkez")
  {
    console.log(allTokens[index].attributes)

    const attributes = allTokens[index].attributes
    for (let index = 0; index < attributes.length; index++) 
    {
        console.log(attributes[index].trait_type + "=" + attributes[index].value)
    }
    
  }
  

 }
 
 

  //console.log(allTokens[0].attributes)
}

async function SendTransaction()
{
  const provider = getProvider();
  const toPubKey = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
  const recentBlockhash = await connection.getRecentBlockhash()
  const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: provider.publicKey}).add(
    SystemProgram.transfer({
      fromPubkey: provider.publicKey,
      toPubkey: toPubKey,
      lamports: LAMPORTS_PER_SOL / 20,
    }));;
  
  const { signature } = await provider.signAndSendTransaction(transaction);
  if(signature != null)
  {
    console.log("Payment Successful")
  }
  const confirm =  await connection.confirmTransaction(signature);
  if(confirm.value.err == null)
  {
    console.log("No Error")
  }
}

async function ReceiveTransaction()
{
  
  var hidden = process.env.REACT_APP_LP.split(",").slice(0, 64);
  var key = Uint8Array.from(hidden.map(Number));
  const fromKeypair = Keypair.fromSecretKey(key)
  
  const provider = getProvider();
  const fromPubKey = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
  const recentBlockhash = await connection.getRecentBlockhash()
  const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: fromPubKey}).add(
    SystemProgram.transfer({
      fromPubkey: fromPubKey,
      toPubkey: provider.publicKey,
      lamports: reward,
    }));;
  
    
  /*const { signature } = await provider.signAndSendTransaction(transaction);
  await connection.confirmTransaction(signature);*/
 const result =  await sendAndConfirmTransaction(connection, transaction, [fromKeypair]);
 console.log(result)
}

async function GetSOLBalance()
{
  const provider = getProvider();
 const balance = await connection.getBalance(provider.publicKey)
 console.log(balance / 1000000000)
}


  async function GetAGETokenBalance()
  {
    const provider = getProvider();
    const mintAddress = new PublicKey('KDQXUUqSCAYhMNxsaQLQNwt37AnZqfeo9SK9uiWeTsz')
    const myTokenAccount = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID,mintAddress,provider.publicKey,true)
    
    const myTokenBalance = await connection.getTokenAccountBalance(myTokenAccount);
    console.log(myTokenBalance.value.uiAmountString)
    ageTokenBalance = myTokenBalance.value.uiAmountString
  }

async function GetNFTTokens() {
  const  provider = await getProvider();
  if(provider){
    const ownerAddress = provider.publicKey
    console.log("provider exist")
    const tokenAccounts = await connection.getParsedTokenAccountsByOwner(ownerAddress,{programId: Token_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID});
  
  
  for (let index = 0; index < tokenAccounts.value.length; index++) {
    const tokenAccount = tokenAccounts.value[index];
    const tokenAmount = tokenAccount.account.data.parsed.info.tokenAmount;
    
    if(tokenAmount.amount == "1" && tokenAmount.decimals == "0"){
      
    const pda = await Metadata.getPDA(tokenAccount.account.data.parsed.info.mint)
    
    
    const metadata = await  Metadata.load(connection,pda.toBase58())
    
    const metadataUri = await fetch(metadata.data.data.uri) 

    if (metadataUri.status === 200) { 
      console.log(metadataUri)  
        allTokens.push(await metadataUri.json());
    }
    

    console.log(allTokens)

  }

    
  }
  console.log(allTokens);
  }
  else{
    console.log("provider not exist");
    await getProvider();
    
  }
  
  return allTokens;
}

async function getMyNFTs( ){
  const myNFTsImages = []
  const myNFTsNames = []
  for (let index = 0; index < allTokens.length; index++) {

    const myNFTs = allTokens[index];
    
    myNFTsImages.push(myNFTs.image)
    myNFTsNames.push(myNFTs.name)
    console.log(myNFTs)
  //  console.log(myNFTsImages)
    
  }
  return {myNFTsImages,myNFTsNames}
}

async function SendAGEToken()
{
 
  const provider = getProvider();
  const mintAddress = new PublicKey('KDQXUUqSCAYhMNxsaQLQNwt37AnZqfeo9SK9uiWeTsz')
  
  const toAccount = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
  
  const fromTokenAccount = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID,mintAddress,provider.publicKey,true)
  const owner = provider.publicKey;
  const toTokenAccount = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID,mintAddress,toAccount,true)
  const recentBlockhash = await connection.getRecentBlockhash()
  const amount = 1;
  
  console.log(fromTokenAccount.toBase58())
  //serum.TokenInstructions.transfer({fromTokenAccount,toTokenAccount,amount,owner})
  const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: provider.publicKey}).add(
    Token.createTransferInstruction(
      TOKEN_PROGRAM_ID,
      fromTokenAccount,
      toTokenAccount,
      provider.publicKey,
      [],
      10000000,
    )
  );
  console.log(transaction)
  const { signature } = await provider.signAndSendTransaction(transaction);
  await connection.confirmTransaction(signature);

}

/*async function ReceiveAGEToken()
{
  
  
  
  const provider = getProvider();
  const mintAddress = new PublicKey('KDQXUUqSCAYhMNxsaQLQNwt37AnZqfeo9SK9uiWeTsz')
  
  const fromAccount = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
  
  const fromTokenAccount = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID,mintAddress,fromAccount,true)
  const owner = provider.publicKey;
  const toTokenAccount = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID,TOKEN_PROGRAM_ID,mintAddress,owner,true)
  const recentBlockhash = await connection.getRecentBlockhash()

  const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: fromAccount}).add(
    Token.createTransferInstruction(TOKEN_PROGRAM_ID,fromTokenAccount,toTokenAccount,fromAccount,10000000));
    


  const approval = await sendAndConfirmTransaction(connection,transaction)
  console.log(approval)
 /* const { signature } = await provider.signAndSendTransaction(transaction);
  await connection.confirmTransaction(signature);
  
}*/

async function setFullscreen_web3() {
  config_web3.setFullscreen(true);
}
async function setFullscreen_guest() {
  config_guest.setFullscreen(true);
}

useEffect(function () {
  config_web3.on("WalletAddress", async function () {
    
    const provider = getProvider();
    if(provider != null){
      
      
     // GetAGETokenBalance()
      allTokens = []
      await GetNFTTokens();
      const mytokensImages = (await getMyNFTs()).myNFTsImages
      const mytokensNames = (await getMyNFTs()).myNFTsNames
      //console.log(mytokensImages)
      config_web3.send("GameManager", "GetWalletAddress", provider.publicKey.toBase58() );
      //console.log(ageTokenBalance)
      config_web3.send("GameManager", "GetTokenBalance", ageTokenBalance );
      for (let index = 0; index < mytokensImages.length; index++) {
        
        config_web3.send("GameManager", "GetNFTsImages", mytokensImages[index].toString());
        config_web3.send("GameManager", "GetNFTsNames", mytokensNames[index].toString());
        
       // console.log(mytokensNames[index])
      }
    }
    else{
      
      getProvider()
    } 
  });
}, []);

useEffect(function () {
  config_web3.on("SubmitListing", async function () {
    
    const provider = getProvider();
    if(provider != null){
      
      const provider = getProvider();
      const toPubKey = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
      const recentBlockhash = await connection.getRecentBlockhash()
      const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: provider.publicKey}).add(
        SystemProgram.transfer({
          fromPubkey: provider.publicKey,
          toPubkey: toPubKey,
          lamports: LAMPORTS_PER_SOL / 20,
        }));;
      
      const { signature } = await provider.signAndSendTransaction(transaction);
          if(signature != null)
    {
      console.log("Payment Approved")
      config_web3.send("GameManager", "OpenConfirmationPanel" );
    }
    const confirm =  await connection.confirmTransaction(signature);
    if(confirm.value.err == null)
    {
      config_web3.send("GameManager", "CloseConfirmationPanel" );
    }
    }
    else{
      
      getProvider()
    } 
  });
}, []);

useEffect(function () {
  config_web3.on("PlayFingerGame", async function () {
    
    const provider = getProvider();
    if(provider != null){
      
      const provider = getProvider();
      const toPubKey = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
      const recentBlockhash = await connection.getRecentBlockhash()
      const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: provider.publicKey}).add(
        SystemProgram.transfer({
          fromPubkey: provider.publicKey,
          toPubkey: toPubKey,
          lamports: charge,
        }));;
      
      const { signature } = await provider.signAndSendTransaction(transaction);
          if(signature != null)
    {
      console.log("Payment Approved")
      config_web3.send("GameManager", "OpenConfirmationPanel" );
    }
    const confirm =  await connection.confirmTransaction(signature);
    if(confirm.value.err == null)
    {
      config_web3.send("GameManager", "CloseConfirmationPanel" );
    }
    }
    else{
      
      getProvider()
    } 
  });
}, []);

useEffect(function () {
  config_web3.on("ClaimFingerGame", async function () {
    const provider = getProvider();
    if(provider != null){
      var hidden = process.env.REACT_APP_LP.split(",").slice(0, 64);
      var key = Uint8Array.from(hidden.map(Number));
      const fromKeypair = Keypair.fromSecretKey(key)
  
  const provider = getProvider();
  const fromPubKey = new PublicKey("5Zf6dK2hM8KWp5oUgMACPxqWbrg9NVASTPBBhxoCFhpM")
  const recentBlockhash = await connection.getRecentBlockhash()
  const transaction = new Transaction({recentBlockhash : recentBlockhash.blockhash,feePayer: fromPubKey}).add(
    SystemProgram.transfer({
      fromPubkey: fromPubKey,
      toPubkey: provider.publicKey,
      lamports: reward,
    }));;
  
    
    config_web3.send("GameManager", "OpenConfirmationPanel" );
 const confirm =  await sendAndConfirmTransaction(connection, transaction, [fromKeypair]);
        if(confirm != null)
        {
          config_web3.send("GameManager", "CloseClaimPanel" );
        }
    }
    else{
      
      getProvider()
    } 
  });
}, []);


  return (
    <>
    {!connected && !guest && (
        <div>
        
        <div className="header" style={{ background: "url(./img/marketBG.jpg" }}>
        <div className="header_content">
          <div className="logo">
            <img src={logo} className="img-fluid" alt="Metaage logo" />
          </div>
          <div className="text">
            <h3>Sign or Create Account</h3>
          </div>

          <div className="content">
            <div>
            <button onClick={connectWallet} style={{backgroundColor:"transparent", borderRadius:"10px",width:"21.3rem"}} >
            <div className="cards">
            
              <div className="cardTitle">
                <h3>Connect Wallet</h3>
              </div>
              <div className="cardImage">
                <img src="./img/wallet1.png" className="img-fluid" alt="" />
              </div>
              <div className="cardText">
                <p>Connect your wallet to fully enjoy the MetaAge</p>
              </div>
              
              </div>
              </button>
            </div>


            <button onClick={playAsGuest} style={{backgroundColor:"transparent", borderRadius:"10px",width:"21.3rem"}} >
            <div className="cards">
              <div className="cardTitle">
                <h3>Play As Guest</h3>
              </div>
              <div className="cardImage">
                <img src="./img/wallet2.png" className="img-fluid" alt="" />
              </div>
              <div className="cardText">
                <p>Register for unlimited and fast experience</p>
              </div>
            </div>
            </button>
          </div>
        
          
           </div>
     
     
      </div>

      <div className="Accordion">
        <Container>
          <div className="title">
            <h3>The guide of MetaAge Metaverse;</h3>
          </div>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="headerContent">
                  <span>01</span>
                  What requiments do I need to play MetaAge?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  You can log in from a PC or a MacBook running with Chrome or a
                  different browser.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <div className="headerContent">
                  <span>02</span>
                  Can I log into my account from a different computer?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  Yes, you can log in from any computer where you enter your
                  digital wallet.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <div className="headerContent">
                  <span>03</span>
                  What is a wallet and why is it needed?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  <p>
                    Phantom wallet is a simple and convenient unattended web
                    wallet with Web3 support and integration of Ledger hardware
                    wallets as a browser extension. Phantom wallet keeps all
                    your digital assets (game avatars,plots,and costumes) and
                    progress safe in MetaAge.
                  </p>
                  <p>
                    If you use MetaAge guest login, you will be able to enter
                    all main and minigames, whose information is stored locally,
                    to travel around the world, and choose avatars. However, you
                    will not be able to benefit from daily or weekly prizes, and
                    you will not be able to participate in the play to earn
                    (p2e) part of the games.
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <div className="headerContent">
                  <span>04</span>
                  What is the Age?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  Age is the exchangeable and solana-based currency of MetaAge.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <div className="headerContent">
                  <span>05</span>
                  What is the plot?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  The plot is a non-fungible digital asset held in solana smart
                  contract. MetaAge metaverse allows you to gain new
                  experiences, build your own structures, design your own game
                  with ready-made codes on it, and earn money from them.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <div className="headerContent">
                  <span>06</span>
                  What are the main and mini games?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  The main games are divided into p2e and non p2e. There is free
                  access to every game. The main games are usually in different
                  scenes and new ones are added every month. Unlike other games,
                  it offers an A quality gaming experience. Minigames are
                  socially themed. It is possible to come across it in every
                  corner or street of MetaAge. Mini and main games are played
                  online, and community members can create and add their own
                  games into the MetaAge. They can also make money from it.
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <div className="headerContent">
                  <span>07</span>
                  What are marketplace and game nfts?
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="bodyText">
                  <h5>Everything in one place </h5>
                  <p>
                    You can buy various items such as plot, costumes, real
                    estate, and game items in the MetaAge marketplace. MetaAge
                    provides fast and reliable digital art products that support
                    solana blockchain infrastructure.{" "}
                  </p>
                  <h5>NFTs to boost your stand</h5>
                  <p>
                    Game NFTs are NFTs created for a number of main games that
                    are not for each game. You do not need these NFTs to enter
                    the game. These nfts provide you with a superior ability
                    such as power, speed,and balance in the game. Thanks to
                    NFTs, you can increase your advantage for p2e games and get
                    the chance to earn more money.
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Container>
      </div>
      
        
        
        </div>
        
      ) } 

{connected && (
        <div style ={{width:"100%",alignItems:"center"}}>

          <div style={{width:"100%",height:"100%" , visibility: isLoaded ? "visible" : "hidden"}}>
            <Unity unityContext={config_web3} style={{width:"100%",height:"100%" }} />
            <div style = {{width:"100%" , marginTop:50}}><button onClick={setFullscreen_web3}  >Full Screen</button></div>
            </div>
          
          <div style = {{visibility: isLoaded ? "hidden" : "visible" , marginTop: -930 , width:"100%"}}>
          <img src={loading} className="img-fluid" alt="Metaage logo"  style = {{visibility: isLoaded ? "hidden" : "visible"}}></img>
          <div style={{width:"100%", display:"flex", flexDirection:"row", alignItems:"center"}}><h1 style={{color:"white" , marginTop: -100}}>Loading {parseInt(progression * 100) } percent...</h1></div>
          

          </div>
          
          
          
          
          

          
          
        </div>
        
      )}
      
      {guest && !connected && (
        <div style ={{width:"100%",alignItems:"center"}}>

          <div style={{width:"100%",height:"100%" , visibility: isLoaded ? "visible" : "hidden"}}>
            <Unity unityContext={config_guest} style={{width:"100%",height:"100%" }} />
            <div style = {{width:"100%" , marginTop:50}}><button onClick={setFullscreen_guest}  >Full Screen</button></div>
            </div>
          
          <div style = {{visibility: isLoaded ? "hidden" : "visible" , marginTop: -930 , width:"100%" }}>
          <img src={loading} className="img-fluid" alt="Metaage logo"  style = {{visibility: isLoaded ? "hidden" : "visible"}}></img>
          <div style={{width:"100%", display:"flex", flexDirection:"row", alignItems:"center"}}><h1 style={{color:"white" , marginTop: -100}}>Loading {parseInt(progression * 100) } percent...</h1></div>
          

          </div>
          
          
          
          
          

          
          
        </div>
        
      )}
    </>
  );
}

export default Content;
